/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AdminTasksImportFromFilePostV2Body,
  BTFileViewer,
  BulkCreateTasksRequest,
  BulkCreateTasksResponse,
  BulkDeleteTasksByExternalIdRequest,
  BulkRestoreTasksByExternalIdRequest,
  CopyTasksToJobRequest,
  CopyTasksToJobResponse,
  CreateTaskRequest,
  GetTaskByExternalIdResponse,
  GetTaskListRequest,
  GetTaskMobileSummaryRequest,
  ImportWizardSummaryResponse,
  Int32BTServiceListItem,
  MassEditOptionsResponse,
  MassUpdateRequest,
  MassUpdateResponse,
  MoveTasksToJobRequest,
  MoveTasksToJobResponse,
  ReorderSubtaskRequest,
  SetTaskAssignmentsRequest,
  SetTaskTagsRequest,
  SubTasksResponse,
  Tag,
  TaskAssignmentSearchResponse,
  TaskBulkPatchRequest,
  TaskContract,
  TaskImportFromFileResponse,
  TaskListResponse,
  TaskMassEditOptionsRequest,
  TaskMediaUploadResponse,
  TaskMobileSummaryResponse,
  TaskRelatedItemsResponse,
  TasksAssignableUsersGetV2Params,
  TasksAssignmentSearchGetV2Params,
  TasksByRelatedEntityGetV2Params,
  TasksDefaultGetV2Params,
  TasksImportFromFilePostV2Body,
  TasksInlineMediaByExternalIdPostV2Body,
  TasksMappingData,
  TasksMassEditGetV2Params,
  TasksPrintByTokenGetV2Params,
  TasksPrintGetV2Params,
  TasksPrintResponse,
  TasksSubTasksByExternalIdGetV2Params,
  TasksSuggestedAssigneesGetV2Params,
  UpdateTaskRequest,
  UpdateTaskStatusRequest,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets all tasks for multiple jobs
 */
export const tasksListPostV2 = (
  getTaskListRequest: BodyType<GetTaskListRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskListResponse>(
    {
      url: `/apix/v2/Tasks/list`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: getTaskListRequest,
      signal,
    },
    options,
  );
};

export const getTasksListPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksListPostV2>>,
    TError,
    { data: BodyType<GetTaskListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksListPostV2>>,
  TError,
  { data: BodyType<GetTaskListRequest> },
  TContext
> => {
  const mutationKey = ["tasksListPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksListPostV2>>,
    { data: BodyType<GetTaskListRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksListPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksListPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksListPostV2>>
>;
export type TasksListPostV2MutationBody = BodyType<GetTaskListRequest>;
export type TasksListPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Gets all tasks for multiple jobs
 */
export const useTasksListPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksListPostV2>>,
    TError,
    { data: BodyType<GetTaskListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksListPostV2>>,
  TError,
  { data: BodyType<GetTaskListRequest> },
  TContext
> => {
  const mutationOptions = getTasksListPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets a single task by external ID
 */
export const tasksByExternalIdGetV2 = (
  externalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetTaskByExternalIdResponse>(
    { url: `/apix/v2/Tasks/${externalId}`, method: "GET", signal },
    options,
  );
};

export const getTasksByExternalIdGetV2QueryKey = (externalId?: string) => {
  return [`/apix/v2/Tasks/${externalId}`] as const;
};

export const getTasksByExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksByExternalIdGetV2QueryKey(externalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksByExternalIdGetV2>>
  > = ({ signal }) =>
    tasksByExternalIdGetV2(externalId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!externalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksByExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksByExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksByExternalIdGetV2>>
>;
export type TasksByExternalIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets a single task by external ID
 */

export function useTasksByExternalIdGetV2<
  TData = Awaited<ReturnType<typeof tasksByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksByExternalIdGetV2QueryOptions(
    externalId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Patches an existing task by external ID using JSON Merge Patch
 */
export const tasksByExternalIdPatchV2 = (
  externalId: string,
  updateTaskRequest: BodyType<UpdateTaskRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<TaskContract>(
    {
      url: `/apix/v2/Tasks/${externalId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateTaskRequest,
    },
    options,
  );
};

export const getTasksByExternalIdPatchV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>,
    TError,
    { externalId: string; data: BodyType<UpdateTaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>,
  TError,
  { externalId: string; data: BodyType<UpdateTaskRequest> },
  TContext
> => {
  const mutationKey = ["tasksByExternalIdPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>,
    { externalId: string; data: BodyType<UpdateTaskRequest> }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksByExternalIdPatchV2(externalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksByExternalIdPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>
>;
export type TasksByExternalIdPatchV2MutationBody = BodyType<UpdateTaskRequest>;
export type TasksByExternalIdPatchV2MutationError = ErrorType<unknown>;

/**
 * @summary Patches an existing task by external ID using JSON Merge Patch
 */
export const useTasksByExternalIdPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>,
    TError,
    { externalId: string; data: BodyType<UpdateTaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksByExternalIdPatchV2>>,
  TError,
  { externalId: string; data: BodyType<UpdateTaskRequest> },
  TContext
> => {
  const mutationOptions = getTasksByExternalIdPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets a default blank task for creating new tasks
 */
export const tasksDefaultGetV2 = (
  params: TasksDefaultGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetTaskByExternalIdResponse>(
    { url: `/apix/v2/Tasks/default`, method: "GET", params, signal },
    options,
  );
};

export const getTasksDefaultGetV2QueryKey = (
  params?: TasksDefaultGetV2Params,
) => {
  return [`/apix/v2/Tasks/default`, ...(params ? [params] : [])] as const;
};

export const getTasksDefaultGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksDefaultGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: TasksDefaultGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksDefaultGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksDefaultGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksDefaultGetV2>>
  > = ({ signal }) => tasksDefaultGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksDefaultGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksDefaultGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksDefaultGetV2>>
>;
export type TasksDefaultGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets a default blank task for creating new tasks
 */

export function useTasksDefaultGetV2<
  TData = Awaited<ReturnType<typeof tasksDefaultGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: TasksDefaultGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksDefaultGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksDefaultGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets sub-tasks for a parent task by external ID
 */
export const tasksSubTasksByExternalIdGetV2 = (
  externalId: string,
  params?: TasksSubTasksByExternalIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SubTasksResponse>(
    {
      url: `/apix/v2/Tasks/${externalId}/sub-tasks`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getTasksSubTasksByExternalIdGetV2QueryKey = (
  externalId?: string,
  params?: TasksSubTasksByExternalIdGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/${externalId}/sub-tasks`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksSubTasksByExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  params?: TasksSubTasksByExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTasksSubTasksByExternalIdGetV2QueryKey(externalId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>
  > = ({ signal }) =>
    tasksSubTasksByExternalIdGetV2(externalId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!externalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksSubTasksByExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>
>;
export type TasksSubTasksByExternalIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets sub-tasks for a parent task by external ID
 */

export function useTasksSubTasksByExternalIdGetV2<
  TData = Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  params?: TasksSubTasksByExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksSubTasksByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksSubTasksByExternalIdGetV2QueryOptions(
    externalId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Creates a new task
 */
export const tasksPostV2 = (
  createTaskRequest: BodyType<CreateTaskRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskContract>(
    {
      url: `/apix/v2/Tasks`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: createTaskRequest,
      signal,
    },
    options,
  );
};

export const getTasksPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPostV2>>,
    TError,
    { data: BodyType<CreateTaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksPostV2>>,
  TError,
  { data: BodyType<CreateTaskRequest> },
  TContext
> => {
  const mutationKey = ["tasksPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksPostV2>>,
    { data: BodyType<CreateTaskRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksPostV2>>
>;
export type TasksPostV2MutationBody = BodyType<CreateTaskRequest>;
export type TasksPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Creates a new task
 */
export const useTasksPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPostV2>>,
    TError,
    { data: BodyType<CreateTaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksPostV2>>,
  TError,
  { data: BodyType<CreateTaskRequest> },
  TContext
> => {
  const mutationOptions = getTasksPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Creates multiple tasks in a single batch operation
 */
export const tasksBulkCreatePostV2 = (
  bulkCreateTasksRequest: BodyType<BulkCreateTasksRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkCreateTasksResponse>(
    {
      url: `/apix/v2/Tasks/bulk-create`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkCreateTasksRequest,
      signal,
    },
    options,
  );
};

export const getTasksBulkCreatePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkCreatePostV2>>,
    TError,
    { data: BodyType<BulkCreateTasksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksBulkCreatePostV2>>,
  TError,
  { data: BodyType<BulkCreateTasksRequest> },
  TContext
> => {
  const mutationKey = ["tasksBulkCreatePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksBulkCreatePostV2>>,
    { data: BodyType<BulkCreateTasksRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksBulkCreatePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksBulkCreatePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksBulkCreatePostV2>>
>;
export type TasksBulkCreatePostV2MutationBody =
  BodyType<BulkCreateTasksRequest>;
export type TasksBulkCreatePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Creates multiple tasks in a single batch operation
 */
export const useTasksBulkCreatePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkCreatePostV2>>,
    TError,
    { data: BodyType<BulkCreateTasksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksBulkCreatePostV2>>,
  TError,
  { data: BodyType<BulkCreateTasksRequest> },
  TContext
> => {
  const mutationOptions = getTasksBulkCreatePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Updates task status by external ID
 */
export const tasksStatusByExternalIdPutV2 = (
  externalId: string,
  updateTaskStatusRequest: BodyType<UpdateTaskStatusRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<TaskContract>(
    {
      url: `/apix/v2/Tasks/status/${externalId}`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateTaskStatusRequest,
    },
    options,
  );
};

export const getTasksStatusByExternalIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<UpdateTaskStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<UpdateTaskStatusRequest> },
  TContext
> => {
  const mutationKey = ["tasksStatusByExternalIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>,
    { externalId: string; data: BodyType<UpdateTaskStatusRequest> }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksStatusByExternalIdPutV2(externalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksStatusByExternalIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>
>;
export type TasksStatusByExternalIdPutV2MutationBody =
  BodyType<UpdateTaskStatusRequest>;
export type TasksStatusByExternalIdPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Updates task status by external ID
 */
export const useTasksStatusByExternalIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<UpdateTaskStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksStatusByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<UpdateTaskStatusRequest> },
  TContext
> => {
  const mutationOptions =
    getTasksStatusByExternalIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Patches existing tasks by external IDs using JSON Merge Patch. Can't apply same patch more than once, hence a list of patch models is required
 */
export const tasksBulkPatchPatchV2 = (
  taskBulkPatchRequest: BodyType<TaskBulkPatchRequest[]>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<TaskContract[]>(
    {
      url: `/apix/v2/Tasks/bulk-patch`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: taskBulkPatchRequest,
    },
    options,
  );
};

export const getTasksBulkPatchPatchV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>,
    TError,
    { data: BodyType<TaskBulkPatchRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>,
  TError,
  { data: BodyType<TaskBulkPatchRequest[]> },
  TContext
> => {
  const mutationKey = ["tasksBulkPatchPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>,
    { data: BodyType<TaskBulkPatchRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksBulkPatchPatchV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksBulkPatchPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>
>;
export type TasksBulkPatchPatchV2MutationBody = BodyType<
  TaskBulkPatchRequest[]
>;
export type TasksBulkPatchPatchV2MutationError = ErrorType<unknown>;

/**
 * @summary Patches existing tasks by external IDs using JSON Merge Patch. Can't apply same patch more than once, hence a list of patch models is required
 */
export const useTasksBulkPatchPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>,
    TError,
    { data: BodyType<TaskBulkPatchRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksBulkPatchPatchV2>>,
  TError,
  { data: BodyType<TaskBulkPatchRequest[]> },
  TContext
> => {
  const mutationOptions = getTasksBulkPatchPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Sets task assignments atomically by external ID
 */
export const tasksAssignmentsByExternalIdPatchV2 = (
  externalId: string,
  setTaskAssignmentsRequest: BodyType<SetTaskAssignmentsRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<TaskContract>(
    {
      url: `/apix/v2/Tasks/${externalId}/assignments`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: setTaskAssignmentsRequest,
    },
    options,
  );
};

export const getTasksAssignmentsByExternalIdPatchV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>,
    TError,
    { externalId: string; data: BodyType<SetTaskAssignmentsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>,
  TError,
  { externalId: string; data: BodyType<SetTaskAssignmentsRequest> },
  TContext
> => {
  const mutationKey = ["tasksAssignmentsByExternalIdPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>,
    { externalId: string; data: BodyType<SetTaskAssignmentsRequest> }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksAssignmentsByExternalIdPatchV2(
      externalId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksAssignmentsByExternalIdPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>
>;
export type TasksAssignmentsByExternalIdPatchV2MutationBody =
  BodyType<SetTaskAssignmentsRequest>;
export type TasksAssignmentsByExternalIdPatchV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Sets task assignments atomically by external ID
 */
export const useTasksAssignmentsByExternalIdPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>,
    TError,
    { externalId: string; data: BodyType<SetTaskAssignmentsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksAssignmentsByExternalIdPatchV2>>,
  TError,
  { externalId: string; data: BodyType<SetTaskAssignmentsRequest> },
  TContext
> => {
  const mutationOptions =
    getTasksAssignmentsByExternalIdPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Sets task tags atomically by external ID
 */
export const tasksTagsByExternalIdPutV2 = (
  externalId: string,
  setTaskTagsRequest: BodyType<SetTaskTagsRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<Int32BTServiceListItem[]>(
    {
      url: `/apix/v2/Tasks/${externalId}/tags`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: setTaskTagsRequest,
    },
    options,
  );
};

export const getTasksTagsByExternalIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<SetTaskTagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<SetTaskTagsRequest> },
  TContext
> => {
  const mutationKey = ["tasksTagsByExternalIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>,
    { externalId: string; data: BodyType<SetTaskTagsRequest> }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksTagsByExternalIdPutV2(externalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksTagsByExternalIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>
>;
export type TasksTagsByExternalIdPutV2MutationBody =
  BodyType<SetTaskTagsRequest>;
export type TasksTagsByExternalIdPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Sets task tags atomically by external ID
 */
export const useTasksTagsByExternalIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<SetTaskTagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksTagsByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<SetTaskTagsRequest> },
  TContext
> => {
  const mutationOptions = getTasksTagsByExternalIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets available task tags for the current builder
 */
export const tasksTagsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Tag[]>(
    { url: `/apix/v2/Tasks/tags`, method: "GET", signal },
    options,
  );
};

export const getTasksTagsGetV2QueryKey = () => {
  return [`/apix/v2/Tasks/tags`] as const;
};

export const getTasksTagsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksTagsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof tasksTagsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksTagsGetV2QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksTagsGetV2>>> = ({
    signal,
  }) => tasksTagsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksTagsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksTagsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksTagsGetV2>>
>;
export type TasksTagsGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets available task tags for the current builder
 */

export function useTasksTagsGetV2<
  TData = Awaited<ReturnType<typeof tasksTagsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof tasksTagsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksTagsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Soft deletes multiple tasks by external IDs
 */
export const tasksBulkDeletePostV2 = (
  bulkDeleteTasksByExternalIdRequest: BodyType<BulkDeleteTasksByExternalIdRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Tasks/bulk-delete`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkDeleteTasksByExternalIdRequest,
      signal,
    },
    options,
  );
};

export const getTasksBulkDeletePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkDeletePostV2>>,
    TError,
    { data: BodyType<BulkDeleteTasksByExternalIdRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksBulkDeletePostV2>>,
  TError,
  { data: BodyType<BulkDeleteTasksByExternalIdRequest> },
  TContext
> => {
  const mutationKey = ["tasksBulkDeletePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksBulkDeletePostV2>>,
    { data: BodyType<BulkDeleteTasksByExternalIdRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksBulkDeletePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksBulkDeletePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksBulkDeletePostV2>>
>;
export type TasksBulkDeletePostV2MutationBody =
  BodyType<BulkDeleteTasksByExternalIdRequest>;
export type TasksBulkDeletePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Soft deletes multiple tasks by external IDs
 */
export const useTasksBulkDeletePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkDeletePostV2>>,
    TError,
    { data: BodyType<BulkDeleteTasksByExternalIdRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksBulkDeletePostV2>>,
  TError,
  { data: BodyType<BulkDeleteTasksByExternalIdRequest> },
  TContext
> => {
  const mutationOptions = getTasksBulkDeletePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Restores multiple soft-deleted tasks by external IDs
 */
export const tasksBulkRestorePostV2 = (
  bulkRestoreTasksByExternalIdRequest: BodyType<BulkRestoreTasksByExternalIdRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Tasks/bulk-restore`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkRestoreTasksByExternalIdRequest,
      signal,
    },
    options,
  );
};

export const getTasksBulkRestorePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkRestorePostV2>>,
    TError,
    { data: BodyType<BulkRestoreTasksByExternalIdRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksBulkRestorePostV2>>,
  TError,
  { data: BodyType<BulkRestoreTasksByExternalIdRequest> },
  TContext
> => {
  const mutationKey = ["tasksBulkRestorePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksBulkRestorePostV2>>,
    { data: BodyType<BulkRestoreTasksByExternalIdRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksBulkRestorePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksBulkRestorePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksBulkRestorePostV2>>
>;
export type TasksBulkRestorePostV2MutationBody =
  BodyType<BulkRestoreTasksByExternalIdRequest>;
export type TasksBulkRestorePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Restores multiple soft-deleted tasks by external IDs
 */
export const useTasksBulkRestorePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksBulkRestorePostV2>>,
    TError,
    { data: BodyType<BulkRestoreTasksByExternalIdRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksBulkRestorePostV2>>,
  TError,
  { data: BodyType<BulkRestoreTasksByExternalIdRequest> },
  TContext
> => {
  const mutationOptions = getTasksBulkRestorePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Searches for users available for task assignment with job context
 */
export const tasksAssignmentSearchGetV2 = (
  params: TasksAssignmentSearchGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskAssignmentSearchResponse>(
    { url: `/apix/v2/Tasks/assignment-search`, method: "GET", params, signal },
    options,
  );
};

export const getTasksAssignmentSearchGetV2QueryKey = (
  params?: TasksAssignmentSearchGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/assignment-search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksAssignmentSearchGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: TasksAssignmentSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksAssignmentSearchGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>
  > = ({ signal }) =>
    tasksAssignmentSearchGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksAssignmentSearchGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>
>;
export type TasksAssignmentSearchGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Searches for users available for task assignment with job context
 */

export function useTasksAssignmentSearchGetV2<
  TData = Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: TasksAssignmentSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAssignmentSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksAssignmentSearchGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Replacement for suggested-assignees. Returns all potential assignees, ordered by most frequently assigned, then name.
 */
export const tasksSuggestedAssigneesGetV2 = (
  params?: TasksSuggestedAssigneesGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Int32BTServiceListItem[]>(
    {
      url: `/apix/v2/Tasks/suggested-assignees`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getTasksSuggestedAssigneesGetV2QueryKey = (
  params?: TasksSuggestedAssigneesGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/suggested-assignees`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksSuggestedAssigneesGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksSuggestedAssigneesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksSuggestedAssigneesGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>
  > = ({ signal }) =>
    tasksSuggestedAssigneesGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksSuggestedAssigneesGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>
>;
export type TasksSuggestedAssigneesGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Replacement for suggested-assignees. Returns all potential assignees, ordered by most frequently assigned, then name.
 */

export function useTasksSuggestedAssigneesGetV2<
  TData = Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksSuggestedAssigneesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksSuggestedAssigneesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksSuggestedAssigneesGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Replacement for suggested-assignees. Returns all potential assignees for a given job or all jobs, ordered by most frequently assigned, then name.
 */
export const tasksAssignableUsersGetV2 = (
  params?: TasksAssignableUsersGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Int32BTServiceListItem[]>(
    { url: `/apix/v2/Tasks/assignable-users`, method: "GET", params, signal },
    options,
  );
};

export const getTasksAssignableUsersGetV2QueryKey = (
  params?: TasksAssignableUsersGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/assignable-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksAssignableUsersGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksAssignableUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksAssignableUsersGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>
  > = ({ signal }) => tasksAssignableUsersGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksAssignableUsersGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>
>;
export type TasksAssignableUsersGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Replacement for suggested-assignees. Returns all potential assignees for a given job or all jobs, ordered by most frequently assigned, then name.
 */

export function useTasksAssignableUsersGetV2<
  TData = Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksAssignableUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAssignableUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksAssignableUsersGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksAttachmentsByExternalIdGetV2 = (
  externalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BTFileViewer>(
    { url: `/apix/v2/Tasks/${externalId}/attachments`, method: "GET", signal },
    options,
  );
};

export const getTasksAttachmentsByExternalIdGetV2QueryKey = (
  externalId?: string,
) => {
  return [`/apix/v2/Tasks/${externalId}/attachments`] as const;
};

export const getTasksAttachmentsByExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTasksAttachmentsByExternalIdGetV2QueryKey(externalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>
  > = ({ signal }) =>
    tasksAttachmentsByExternalIdGetV2(externalId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!externalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksAttachmentsByExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>
>;
export type TasksAttachmentsByExternalIdGetV2QueryError = ErrorType<unknown>;

export function useTasksAttachmentsByExternalIdGetV2<
  TData = Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksAttachmentsByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksAttachmentsByExternalIdGetV2QueryOptions(
    externalId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Uploads an inline media file uploaded under a task's description.
 */
export const tasksInlineMediaByExternalIdPostV2 = (
  externalId: string,
  tasksInlineMediaByExternalIdPostV2Body: BodyType<TasksInlineMediaByExternalIdPostV2Body>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (tasksInlineMediaByExternalIdPostV2Body.file !== undefined) {
    formData.append(`file`, tasksInlineMediaByExternalIdPostV2Body.file);
  }

  return apixHandler<TaskMediaUploadResponse>(
    {
      url: `/apix/v2/Tasks/${externalId}/inline-media`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTasksInlineMediaByExternalIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>,
    TError,
    {
      externalId: string;
      data: BodyType<TasksInlineMediaByExternalIdPostV2Body>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>,
  TError,
  {
    externalId: string;
    data: BodyType<TasksInlineMediaByExternalIdPostV2Body>;
  },
  TContext
> => {
  const mutationKey = ["tasksInlineMediaByExternalIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>,
    {
      externalId: string;
      data: BodyType<TasksInlineMediaByExternalIdPostV2Body>;
    }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksInlineMediaByExternalIdPostV2(externalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksInlineMediaByExternalIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>
>;
export type TasksInlineMediaByExternalIdPostV2MutationBody =
  BodyType<TasksInlineMediaByExternalIdPostV2Body>;
export type TasksInlineMediaByExternalIdPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Uploads an inline media file uploaded under a task's description.
 */
export const useTasksInlineMediaByExternalIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>,
    TError,
    {
      externalId: string;
      data: BodyType<TasksInlineMediaByExternalIdPostV2Body>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksInlineMediaByExternalIdPostV2>>,
  TError,
  {
    externalId: string;
    data: BodyType<TasksInlineMediaByExternalIdPostV2Body>;
  },
  TContext
> => {
  const mutationOptions =
    getTasksInlineMediaByExternalIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets schedules linked to a task by external ID
 */
export const tasksLinkedSchedulesByExternalIdGetV2 = (
  externalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskRelatedItemsResponse>(
    {
      url: `/apix/v2/Tasks/${externalId}/linked-schedules`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getTasksLinkedSchedulesByExternalIdGetV2QueryKey = (
  externalId?: string,
) => {
  return [`/apix/v2/Tasks/${externalId}/linked-schedules`] as const;
};

export const getTasksLinkedSchedulesByExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTasksLinkedSchedulesByExternalIdGetV2QueryKey(externalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>
  > = ({ signal }) =>
    tasksLinkedSchedulesByExternalIdGetV2(externalId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!externalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksLinkedSchedulesByExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>
>;
export type TasksLinkedSchedulesByExternalIdGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets schedules linked to a task by external ID
 */

export function useTasksLinkedSchedulesByExternalIdGetV2<
  TData = Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksLinkedSchedulesByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksLinkedSchedulesByExternalIdGetV2QueryOptions(
    externalId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets tasks linked to a related entity (e.g. a Daily Log) via entity record links
 */
export const tasksByRelatedEntityGetV2 = (
  params?: TasksByRelatedEntityGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskContract[]>(
    { url: `/apix/v2/Tasks/by-related-entity`, method: "GET", params, signal },
    options,
  );
};

export const getTasksByRelatedEntityGetV2QueryKey = (
  params?: TasksByRelatedEntityGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/by-related-entity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksByRelatedEntityGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksByRelatedEntityGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksByRelatedEntityGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>
  > = ({ signal }) => tasksByRelatedEntityGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksByRelatedEntityGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>
>;
export type TasksByRelatedEntityGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets tasks linked to a related entity (e.g. a Daily Log) via entity record links
 */

export function useTasksByRelatedEntityGetV2<
  TData = Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksByRelatedEntityGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksByRelatedEntityGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksByRelatedEntityGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Creates a new task linked to one or more related entities
 */
export const tasksFromRelatedEntityPostV2 = (
  tasksMappingData: BodyType<TasksMappingData>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskContract>(
    {
      url: `/apix/v2/Tasks/from-related-entity`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: tasksMappingData,
      signal,
    },
    options,
  );
};

export const getTasksFromRelatedEntityPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>,
    TError,
    { data: BodyType<TasksMappingData> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>,
  TError,
  { data: BodyType<TasksMappingData> },
  TContext
> => {
  const mutationKey = ["tasksFromRelatedEntityPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>,
    { data: BodyType<TasksMappingData> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksFromRelatedEntityPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksFromRelatedEntityPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>
>;
export type TasksFromRelatedEntityPostV2MutationBody =
  BodyType<TasksMappingData>;
export type TasksFromRelatedEntityPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Creates a new task linked to one or more related entities
 */
export const useTasksFromRelatedEntityPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>,
    TError,
    { data: BodyType<TasksMappingData> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksFromRelatedEntityPostV2>>,
  TError,
  { data: BodyType<TasksMappingData> },
  TContext
> => {
  const mutationOptions =
    getTasksFromRelatedEntityPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Moves tasks to a different job
 */
export const tasksMoveToJobPostV2 = (
  moveTasksToJobRequest: BodyType<MoveTasksToJobRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MoveTasksToJobResponse>(
    {
      url: `/apix/v2/Tasks/move-to-job`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: moveTasksToJobRequest,
      signal,
    },
    options,
  );
};

export const getTasksMoveToJobPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMoveToJobPostV2>>,
    TError,
    { data: BodyType<MoveTasksToJobRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksMoveToJobPostV2>>,
  TError,
  { data: BodyType<MoveTasksToJobRequest> },
  TContext
> => {
  const mutationKey = ["tasksMoveToJobPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksMoveToJobPostV2>>,
    { data: BodyType<MoveTasksToJobRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksMoveToJobPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksMoveToJobPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksMoveToJobPostV2>>
>;
export type TasksMoveToJobPostV2MutationBody = BodyType<MoveTasksToJobRequest>;
export type TasksMoveToJobPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Moves tasks to a different job
 */
export const useTasksMoveToJobPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMoveToJobPostV2>>,
    TError,
    { data: BodyType<MoveTasksToJobRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksMoveToJobPostV2>>,
  TError,
  { data: BodyType<MoveTasksToJobRequest> },
  TContext
> => {
  const mutationOptions = getTasksMoveToJobPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Copies tasks to a different job
 */
export const tasksCopyToJobPostV2 = (
  copyTasksToJobRequest: BodyType<CopyTasksToJobRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CopyTasksToJobResponse>(
    {
      url: `/apix/v2/Tasks/copy-to-job`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: copyTasksToJobRequest,
      signal,
    },
    options,
  );
};

export const getTasksCopyToJobPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksCopyToJobPostV2>>,
    TError,
    { data: BodyType<CopyTasksToJobRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksCopyToJobPostV2>>,
  TError,
  { data: BodyType<CopyTasksToJobRequest> },
  TContext
> => {
  const mutationKey = ["tasksCopyToJobPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksCopyToJobPostV2>>,
    { data: BodyType<CopyTasksToJobRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksCopyToJobPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksCopyToJobPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksCopyToJobPostV2>>
>;
export type TasksCopyToJobPostV2MutationBody = BodyType<CopyTasksToJobRequest>;
export type TasksCopyToJobPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Copies tasks to a different job
 */
export const useTasksCopyToJobPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksCopyToJobPostV2>>,
    TError,
    { data: BodyType<CopyTasksToJobRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksCopyToJobPostV2>>,
  TError,
  { data: BodyType<CopyTasksToJobRequest> },
  TContext
> => {
  const mutationOptions = getTasksCopyToJobPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Legacy GET form of the mass-edit options preflight. Selections larger than ~470 task IDs
exceed the request-line size limit; use POST mass-edit-options for those.
 */
export const tasksMassEditGetV2 = (
  params?: TasksMassEditGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassEditOptionsResponse>(
    { url: `/apix/v2/Tasks/mass-edit`, method: "GET", params, signal },
    options,
  );
};

export const getTasksMassEditGetV2QueryKey = (
  params?: TasksMassEditGetV2Params,
) => {
  return [`/apix/v2/Tasks/mass-edit`, ...(params ? [params] : [])] as const;
};

export const getTasksMassEditGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksMassEditGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksMassEditGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksMassEditGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksMassEditGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksMassEditGetV2>>
  > = ({ signal }) => tasksMassEditGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksMassEditGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksMassEditGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksMassEditGetV2>>
>;
export type TasksMassEditGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Legacy GET form of the mass-edit options preflight. Selections larger than ~470 task IDs
exceed the request-line size limit; use POST mass-edit-options for those.
 */

export function useTasksMassEditGetV2<
  TData = Awaited<ReturnType<typeof tasksMassEditGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksMassEditGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksMassEditGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksMassEditGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksMassEditPutV2 = (
  massUpdateRequest: BodyType<MassUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<MassUpdateResponse>(
    {
      url: `/apix/v2/Tasks/mass-edit`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massUpdateRequest,
    },
    options,
  );
};

export const getTasksMassEditPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMassEditPutV2>>,
    TError,
    { data: BodyType<MassUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksMassEditPutV2>>,
  TError,
  { data: BodyType<MassUpdateRequest> },
  TContext
> => {
  const mutationKey = ["tasksMassEditPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksMassEditPutV2>>,
    { data: BodyType<MassUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksMassEditPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksMassEditPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksMassEditPutV2>>
>;
export type TasksMassEditPutV2MutationBody = BodyType<MassUpdateRequest>;
export type TasksMassEditPutV2MutationError = ErrorType<unknown>;

export const useTasksMassEditPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMassEditPutV2>>,
    TError,
    { data: BodyType<MassUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksMassEditPutV2>>,
  TError,
  { data: BodyType<MassUpdateRequest> },
  TContext
> => {
  const mutationOptions = getTasksMassEditPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksMassEditOptionsPostV2 = (
  taskMassEditOptionsRequest: BodyType<TaskMassEditOptionsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassEditOptionsResponse>(
    {
      url: `/apix/v2/Tasks/mass-edit-options`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: taskMassEditOptionsRequest,
      signal,
    },
    options,
  );
};

export const getTasksMassEditOptionsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>,
    TError,
    { data: BodyType<TaskMassEditOptionsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>,
  TError,
  { data: BodyType<TaskMassEditOptionsRequest> },
  TContext
> => {
  const mutationKey = ["tasksMassEditOptionsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>,
    { data: BodyType<TaskMassEditOptionsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksMassEditOptionsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksMassEditOptionsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>
>;
export type TasksMassEditOptionsPostV2MutationBody =
  BodyType<TaskMassEditOptionsRequest>;
export type TasksMassEditOptionsPostV2MutationError = ErrorType<unknown>;

export const useTasksMassEditOptionsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>,
    TError,
    { data: BodyType<TaskMassEditOptionsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksMassEditOptionsPostV2>>,
  TError,
  { data: BodyType<TaskMassEditOptionsRequest> },
  TContext
> => {
  const mutationOptions = getTasksMassEditOptionsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksPrintGetV2 = (
  params?: TasksPrintGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TasksPrintResponse>(
    { url: `/apix/v2/Tasks/print`, method: "GET", params, signal },
    options,
  );
};

export const getTasksPrintGetV2QueryKey = (params?: TasksPrintGetV2Params) => {
  return [`/apix/v2/Tasks/print`, ...(params ? [params] : [])] as const;
};

export const getTasksPrintGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksPrintGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksPrintGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksPrintGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksPrintGetV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksPrintGetV2>>> = ({
    signal,
  }) => tasksPrintGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksPrintGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksPrintGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksPrintGetV2>>
>;
export type TasksPrintGetV2QueryError = ErrorType<unknown>;

export function useTasksPrintGetV2<
  TData = Awaited<ReturnType<typeof tasksPrintGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksPrintGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksPrintGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksPrintGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksPrintByTokenGetV2 = (
  params?: TasksPrintByTokenGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TasksPrintResponse>(
    { url: `/apix/v2/Tasks/print/by-token`, method: "GET", params, signal },
    options,
  );
};

export const getTasksPrintByTokenGetV2QueryKey = (
  params?: TasksPrintByTokenGetV2Params,
) => {
  return [
    `/apix/v2/Tasks/print/by-token`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTasksPrintByTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksPrintByTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTasksPrintByTokenGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>
  > = ({ signal }) => tasksPrintByTokenGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TasksPrintByTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>
>;
export type TasksPrintByTokenGetV2QueryError = ErrorType<unknown>;

export function useTasksPrintByTokenGetV2<
  TData = Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: TasksPrintByTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tasksPrintByTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTasksPrintByTokenGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const tasksPrintTokenPostV2 = (
  tasksPrintTokenPostV2Body: BodyType<string[]>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<string>(
    {
      url: `/apix/v2/Tasks/print/token`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: tasksPrintTokenPostV2Body,
      signal,
    },
    options,
  );
};

export const getTasksPrintTokenPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPrintTokenPostV2>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksPrintTokenPostV2>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationKey = ["tasksPrintTokenPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksPrintTokenPostV2>>,
    { data: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksPrintTokenPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksPrintTokenPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksPrintTokenPostV2>>
>;
export type TasksPrintTokenPostV2MutationBody = BodyType<string[]>;
export type TasksPrintTokenPostV2MutationError = ErrorType<unknown>;

export const useTasksPrintTokenPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPrintTokenPostV2>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksPrintTokenPostV2>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationOptions = getTasksPrintTokenPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Imports tasks from an Excel or CSV file with AI-powered column mapping
 */
export const tasksImportFromFilePostV2 = (
  tasksImportFromFilePostV2Body: BodyType<TasksImportFromFilePostV2Body>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (tasksImportFromFilePostV2Body.file !== undefined) {
    formData.append(`file`, tasksImportFromFilePostV2Body.file);
  }
  if (tasksImportFromFilePostV2Body.jobId !== undefined) {
    formData.append(`jobId`, tasksImportFromFilePostV2Body.jobId.toString());
  }

  return apixHandler<TaskImportFromFileResponse>(
    {
      url: `/apix/v2/Tasks/import-from-file`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTasksImportFromFilePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksImportFromFilePostV2>>,
    TError,
    { data: BodyType<TasksImportFromFilePostV2Body> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksImportFromFilePostV2>>,
  TError,
  { data: BodyType<TasksImportFromFilePostV2Body> },
  TContext
> => {
  const mutationKey = ["tasksImportFromFilePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksImportFromFilePostV2>>,
    { data: BodyType<TasksImportFromFilePostV2Body> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksImportFromFilePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksImportFromFilePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksImportFromFilePostV2>>
>;
export type TasksImportFromFilePostV2MutationBody =
  BodyType<TasksImportFromFilePostV2Body>;
export type TasksImportFromFilePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Imports tasks from an Excel or CSV file with AI-powered column mapping
 */
export const useTasksImportFromFilePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksImportFromFilePostV2>>,
    TError,
    { data: BodyType<TasksImportFromFilePostV2Body> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksImportFromFilePostV2>>,
  TError,
  { data: BodyType<TasksImportFromFilePostV2Body> },
  TContext
> => {
  const mutationOptions = getTasksImportFromFilePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets a summary of tasks assigned to the current user for the mobile summary grid.
Returns parent tasks only (no subtasks), ordered by end date, start date, then title.
 */
export const tasksMyTasksPostV2 = (
  getTaskMobileSummaryRequest: BodyType<GetTaskMobileSummaryRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskMobileSummaryResponse>(
    {
      url: `/apix/v2/Tasks/my-tasks`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: getTaskMobileSummaryRequest,
      signal,
    },
    options,
  );
};

export const getTasksMyTasksPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMyTasksPostV2>>,
    TError,
    { data: BodyType<GetTaskMobileSummaryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksMyTasksPostV2>>,
  TError,
  { data: BodyType<GetTaskMobileSummaryRequest> },
  TContext
> => {
  const mutationKey = ["tasksMyTasksPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksMyTasksPostV2>>,
    { data: BodyType<GetTaskMobileSummaryRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return tasksMyTasksPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksMyTasksPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksMyTasksPostV2>>
>;
export type TasksMyTasksPostV2MutationBody =
  BodyType<GetTaskMobileSummaryRequest>;
export type TasksMyTasksPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Gets a summary of tasks assigned to the current user for the mobile summary grid.
Returns parent tasks only (no subtasks), ordered by end date, start date, then title.
 */
export const useTasksMyTasksPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksMyTasksPostV2>>,
    TError,
    { data: BodyType<GetTaskMobileSummaryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksMyTasksPostV2>>,
  TError,
  { data: BodyType<GetTaskMobileSummaryRequest> },
  TContext
> => {
  const mutationOptions = getTasksMyTasksPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Reorders a subtask relative to an adjacent sibling within the same parent
 */
export const tasksReorderByExternalIdPutV2 = (
  externalId: string,
  reorderSubtaskRequest: BodyType<ReorderSubtaskRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Tasks/${externalId}/reorder`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: reorderSubtaskRequest,
    },
    options,
  );
};

export const getTasksReorderByExternalIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<ReorderSubtaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<ReorderSubtaskRequest> },
  TContext
> => {
  const mutationKey = ["tasksReorderByExternalIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>,
    { externalId: string; data: BodyType<ReorderSubtaskRequest> }
  > = (props) => {
    const { externalId, data } = props ?? {};

    return tasksReorderByExternalIdPutV2(externalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksReorderByExternalIdPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>
>;
export type TasksReorderByExternalIdPutV2MutationBody =
  BodyType<ReorderSubtaskRequest>;
export type TasksReorderByExternalIdPutV2MutationError = ErrorType<unknown>;

/**
 * @summary Reorders a subtask relative to an adjacent sibling within the same parent
 */
export const useTasksReorderByExternalIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>,
    TError,
    { externalId: string; data: BodyType<ReorderSubtaskRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksReorderByExternalIdPutV2>>,
  TError,
  { externalId: string; data: BodyType<ReorderSubtaskRequest> },
  TContext
> => {
  const mutationOptions =
    getTasksReorderByExternalIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Permanently deletes a soft-deleted task. This action cannot be undone.
 */
export const tasksPermanentByExternalIdDeleteV2 = (
  externalId: string,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Tasks/${externalId}/permanent`, method: "DELETE" },
    options,
  );
};

export const getTasksPermanentByExternalIdDeleteV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>,
    TError,
    { externalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>,
  TError,
  { externalId: string },
  TContext
> => {
  const mutationKey = ["tasksPermanentByExternalIdDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>,
    { externalId: string }
  > = (props) => {
    const { externalId } = props ?? {};

    return tasksPermanentByExternalIdDeleteV2(externalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksPermanentByExternalIdDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>
>;

export type TasksPermanentByExternalIdDeleteV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Permanently deletes a soft-deleted task. This action cannot be undone.
 */
export const useTasksPermanentByExternalIdDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>,
    TError,
    { externalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksPermanentByExternalIdDeleteV2>>,
  TError,
  { externalId: string },
  TContext
> => {
  const mutationOptions =
    getTasksPermanentByExternalIdDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 * @summary BTAdmin variant of the task file import. Imports tasks from a spreadsheet
into the specified job for the specified builder, attributing creation to
a builder admin user. Used by the BTAdmin Builder Setup page's task-import step.
 */
export const adminTasksImportFromFilePostV2 = (
  adminTasksImportFromFilePostV2Body: BodyType<AdminTasksImportFromFilePostV2Body>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (adminTasksImportFromFilePostV2Body.file !== undefined) {
    formData.append(`file`, adminTasksImportFromFilePostV2Body.file);
  }
  if (adminTasksImportFromFilePostV2Body.builderId !== undefined) {
    formData.append(
      `builderId`,
      adminTasksImportFromFilePostV2Body.builderId.toString(),
    );
  }
  if (adminTasksImportFromFilePostV2Body.jobId !== undefined) {
    formData.append(
      `jobId`,
      adminTasksImportFromFilePostV2Body.jobId.toString(),
    );
  }

  return apixHandler<ImportWizardSummaryResponse>(
    {
      url: `/apix/v2/admin/Tasks/import-from-file`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getAdminTasksImportFromFilePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>,
    TError,
    { data: BodyType<AdminTasksImportFromFilePostV2Body> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>,
  TError,
  { data: BodyType<AdminTasksImportFromFilePostV2Body> },
  TContext
> => {
  const mutationKey = ["adminTasksImportFromFilePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>,
    { data: BodyType<AdminTasksImportFromFilePostV2Body> }
  > = (props) => {
    const { data } = props ?? {};

    return adminTasksImportFromFilePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTasksImportFromFilePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>
>;
export type AdminTasksImportFromFilePostV2MutationBody =
  BodyType<AdminTasksImportFromFilePostV2Body>;
export type AdminTasksImportFromFilePostV2MutationError = ErrorType<unknown>;

/**
 * @summary BTAdmin variant of the task file import. Imports tasks from a spreadsheet
into the specified job for the specified builder, attributing creation to
a builder admin user. Used by the BTAdmin Builder Setup page's task-import step.
 */
export const useAdminTasksImportFromFilePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>,
    TError,
    { data: BodyType<AdminTasksImportFromFilePostV2Body> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminTasksImportFromFilePostV2>>,
  TError,
  { data: BodyType<AdminTasksImportFromFilePostV2Body> },
  TContext
> => {
  const mutationOptions =
    getAdminTasksImportFromFilePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
